import { useInjection } from '@cp/shared/di';
import { ADMIN_ROUTE_RESOLVER } from './di';

export const useAdminRouteResolver = () => useInjection(ADMIN_ROUTE_RESOLVER);
